const getLanguage = (locale: string) => {
    switch (locale) {
        case 'nl':
            return 'nl-NL';
        case 'de':
            return 'de-DE';
        case 'en':
        default:
            return 'en-US';
    }
};
export default getLanguage;
